import styled from 'styled-components';
import colors from '../../../../assets/colors';

export const Content = styled.div`
  h2 {
    font-size: 1.2rem;
    margin: 20px -1px 20px;

    :first-child {
      margin: -5px -1px 5px;
    }
  }

  p.subtitle { margin-bottom: 20px }

  @media screen and (max-width: 768px) {
    h2 { margin-top: 40px; }
  }
`;

export const Button = styled.button`
  width: 130px;
  padding: 11px 0;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  cursor: pointer;

  :hover { opacity: .9 }
`;
